const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "gear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.5 5.5L14.0571 4.39272C13.8841 3.96016 13.7976 3.74388 13.6654 3.57511C13.4719 3.32808 13.2058 3.14794 12.9046 3.06005C12.6988 3 12.4659 3 12 3V3C11.5341 3 11.3012 3 11.0954 3.06005C10.7942 3.14794 10.5281 3.32808 10.3346 3.57511C10.2024 3.74388 10.1159 3.96016 9.94291 4.39272L9.5 5.5M14.5 18.5L14.0571 19.6073C13.8841 20.0398 13.7976 20.2561 13.6654 20.4249C13.4719 20.6719 13.2058 20.8521 12.9046 20.94C12.6988 21 12.4659 21 12 21V21C11.5341 21 11.3012 21 11.0954 20.94C10.7942 20.8521 10.5281 20.6719 10.3346 20.4249C10.2024 20.2561 10.1159 20.0398 9.94291 19.6073L9.5 18.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M9.5 5.5L7.7982 4.93273C7.39331 4.79777 7.19086 4.73029 6.99237 4.71872C6.7008 4.70174 6.41062 4.77024 6.15742 4.91583C5.98506 5.01494 5.83417 5.16583 5.53238 5.46762V5.46762C5.21163 5.78837 5.05125 5.94875 4.94937 6.13181C4.79968 6.40077 4.73636 6.70926 4.768 7.01543C4.78953 7.22383 4.87377 7.43441 5.04223 7.85558L5.5 9M14.5 18.5L16.1584 19.0528C16.6054 19.2018 16.829 19.2763 17.0486 19.2831C17.3127 19.2913 17.5742 19.2295 17.8067 19.1041C18.0002 18.9998 18.1668 18.8332 18.5 18.5V18.5C18.8332 18.1668 18.9998 18.0002 19.1041 17.8067C19.2295 17.5742 19.2913 17.3127 19.2831 17.0486C19.2763 16.829 19.2018 16.6054 19.0528 16.1584L18.5 14.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M14.5 5.5L16.2018 4.93273C16.6067 4.79777 16.8091 4.73029 17.0076 4.71872C17.2992 4.70174 17.5894 4.77024 17.8426 4.91583C18.0149 5.01494 18.1658 5.16583 18.4676 5.46762V5.46762C18.7884 5.78837 18.9487 5.94875 19.0506 6.13181C19.2003 6.40077 19.2636 6.70926 19.232 7.01543C19.2105 7.22383 19.1262 7.43441 18.9578 7.85558L18.5 9M5.5 14.5L4.94721 16.1584C4.79819 16.6054 4.72367 16.829 4.7169 17.0486C4.70875 17.3127 4.77049 17.5742 4.89587 17.8067C5.00015 18.0002 5.16677 18.1668 5.5 18.5V18.5C5.83323 18.8332 5.99985 18.9998 6.19325 19.1041C6.4258 19.2295 6.68733 19.2913 6.9514 19.2831C7.17102 19.2763 7.39456 19.2018 7.84164 19.0528L9.5 18.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M5.5 9L4.16521 9.80087C3.74031 10.0558 3.52786 10.1833 3.37354 10.3588C3.23698 10.5141 3.13401 10.696 3.07109 10.893C3 11.1156 3 11.3658 3 11.8663V11.8663C3 12.4589 3 12.7551 3.09462 13.0088C3.17823 13.2329 3.31422 13.4337 3.49124 13.5946C3.69158 13.7766 3.96394 13.8856 4.50866 14.1035L5.5 14.5M18.5 9L19.8348 9.80087C20.2597 10.0558 20.4721 10.1833 20.6265 10.3588C20.763 10.5141 20.866 10.696 20.9289 10.893C21 11.1156 21 11.3658 21 11.8663V11.8663C21 12.4589 21 12.7551 20.9054 13.0088C20.8218 13.2329 20.6858 13.4337 20.5088 13.5946C20.3084 13.7766 20.0361 13.8856 19.4913 14.1035L18.5 14.5",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Icon_5",
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.ce6ff7a425477085a16bda52e787cb51.svg";
export { ForwardRef as ReactComponent };